import { useParams } from "react-router";

import { Spinner } from "@prequel/shared-components";

import DestinationHeader from "../DestinationHeader";
import RetryTransferButton from "./RetryTransferButton";
import TransferDetailsSection from "./TransferDetailsSection";

import { useDestination } from "@/api/queries/destinations";
import { usePostTransfer, useTransfer } from "@/api/queries/transfers";
import Breadcrumbs from "@/components/Breadcrumbs";

const TransferDetails = () => {
  const { destinationID, transferID } = useParams<{
    destinationID: string;
    transferID: string;
  }>();

  const { data: transfer, isLoading: isLoadingTransfer } = useTransfer(transferID);

  // Use the destination from transfer if available, otherwise from URL param
  const destId = transfer?.destination_id || destinationID;

  const { data: destination, isLoading: isLoadingDestination } = useDestination(destId!);
  const postTransferMutation = usePostTransfer();

  if (isLoadingTransfer || isLoadingDestination || !destination || !transfer) {
    return <Spinner />;
  }

  const customTitle = `Transfer Job`;

  return (
    <div className="px-7 py-4">
      <DestinationHeader
        connection={destination}
        customTitle={customTitle}
        breadcrumbs={<Breadcrumbs dynamicLabel={destination.name} />}
      >
        <RetryTransferButton
          destination={destination}
          transfer={transfer}
          isPostingTransfer={postTransferMutation.isPending}
        />
      </DestinationHeader>
      <div className="flex-1">
        <div className="relative mx-auto">
          <div className="pb-16">
            <div className="pb-6">
              <TransferDetailsSection transfer={transfer} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferDetails;
